<template>
  <div class="gap f-s-s w-100 h-100">
    <div class="mobileNavBar f-c-b w-100">
      <b-button class="hambergerBtn d-none" v-b-toggle.sidebar-right>
        <b-img :src="require(`@/assets/images/mobile/hamburgers.svg`)" fluid></b-img>
      </b-button>
      <div class="mobileLogo">
        {{ appTitle }}
      </div>
      <img
        class="ml-2 cp"
        @click.prevent="exitFunc()"
        :src="require(`@/assets/images/gap/exit.svg`)"
      />
    </div>
    <div class="rightNav f-c-b f-d-c h-100" :class="[isHide ? 'width0' : '']">
      <b-img
        v-if="isHide"
        class="rightnavbarhide f-c-c"
        @click="hideNavFunc()"
        :src="require(`@/assets/images/right.svg`)"
        fluid
      ></b-img>
      <b-img
        v-else
        class="rightnavbarhide f-c-c"
        @click="hideNavFunc()"
        :src="require(`@/assets/images/left.svg`)"
        fluid
      ></b-img>
      <div class="up f-e-c f-d-c w-100">
        <div class="rightnavlogo w-100" :class="[isHide ? 'd-none' : 'f-c-c']">
          <b-img :src="require(`@/assets/images/home/vadaroom-logo-white.png`)" fluid></b-img>
        </div>
        <div
          class="f-e-c f-d-c w-100"
          v-for="(v, i) in navItems"
          :key="i"
          :class="[v.children.length && activeId == i ? 'mb-2' : 'mb-3']"
        >
          <div v-if="v.permision" class="f-c-e w-100">
            <a @click.prevent="selectNavFunc(v, i)" class="f-c-s f-d-c">
              <div class="up f-c-s w-100" :class="[activeId == i ? 'activeItem mb-2' : '']">
                <img
                  class="navItem"
                  :src="
                    activeId == i
                      ? require(`@/assets/images/gap/${v.greenIcon}.svg`)
                      : require(`@/assets/images/gap/${v.whiteIcon}.svg`)
                  "
                />
                <div v-if="showMenu" class="linkText f-c-b w-100 w3-animate-opacity">
                  <span>{{ v.name }}</span>
                  <img
                    v-if="v.children.length"
                    :class="[activeId == i ? 'rotateImage' : '']"
                    :src="
                      activeId == i
                        ? require(`@/assets/images/gap/felesh-blue.svg`)
                        : require(`@/assets/images/gap/felesh-white.svg`)
                    "
                  />
                </div>
              </div>
            </a>
          </div>
          <div
            v-if="v.children.length && activeId == i && showMenu && v.permision"
            class="children f-e-c f-d-c w-100 w3-animate-opacity"
          >
            <div v-for="(ch, j) in v.children" :key="j" class="f-c-e w-100">
              <div
                v-if="ch.permision"
                class="childrenItem f-c-s"
                @click.prevent="childSelectFunc(ch, j)"
                :class="[childActiveId == ch.id ? 'childActive' : '']"
              >
                {{ ch.name }}
              </div>
            </div>
          </div>
          <!-- <div
            v-if="
              v.children.length &&
              activeId == i &&
              v.permision &&
              isHide &&
              isabmenu
            "
            class="abmenu f-e-c f-d-c w3-animate-opacity"
          >
            <div v-for="(ch, j) in v.children" :key="j" class="f-c-s w-100">
              <div
                v-if="ch.permision"
                class="childrenItem f-c-s"
                @click.prevent="childSelectFunc(ch, j)"
                :class="[childActiveId == ch.id ? 'childActive' : '']"
              >
                {{ ch.name }}
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="down f-c-c f-d-c w-100">
        <div class="mb-3 f-c-c" :class="[isHide ? 'hideExit' : '']">
          <img
            class=""
            :class="[isHide ? '' : 'ml-2']"
            @click.prevent="exitFunc()"
            :src="require(`@/assets/images/gap/exit.svg`)"
          />
          <div class="exit" @click.prevent="exitFunc()">خروج</div>
        </div>
        <!-- <a
          data-v-efcdee58=""
          :class="[isHide ? 'd-none' : '']"
          style="width: 80px; height: 80px"
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          ><img
            data-v-efcdee58=""
            referrerpolicy="origin"
            src="https://vadaroom.ec.iau.ir/img/logo_enamad.png"
            alt=""
            id="bjOij5apDKj7OdTL5Wi7"
            style="cursor: pointer; width: 100%; height: 100%"
        /></a> -->
        <!-- <a
          :class="[isHide ? 'd-none' : '']"
          style="width: 80px; height: 80px"
          referrerpolicy="origin"
          target="_blank"
          href="https://trustseal.enamad.ir/?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
          ><img
            referrerpolicy="origin"
            src="https://Trustseal.eNamad.ir/logo.aspx?id=326758&amp;Code=bjOij5apDKj7OdTL5Wi7"
            alt=""
            style="cursor: pointer; width: 100%; height: 100%"
            id="bjOij5apDKj7OdTL5Wi7"
        /></a> -->
      </div>
    </div>
    <div class="mobileFooterSection f-c-b w-100">
      <div v-for="(v, i) in navItems" :key="i" class="footerItem f-c-c w-100">
        <div v-if="v.permision" class="f-c-c w-100">
          <img
            @click.prevent="selectNavFunc(v, i)"
            :src="
              require(`@/assets/images/mobile/${footerActiveId == i ? v.activePic : v.pic}.svg`)
            "
          />
        </div>
        <div
          v-if="isChild && footerActiveId == i && v.permision"
          class="childrenSec f-c-c f-d-c"
          :style="{ top: i == 1 ? '-185px' : '-115px' }"
        >
          <div v-for="(c, j) in v.children" :key="j" @click.prevent="childSelectFunc(c)">
            <div v-if="c.permision">
              {{ c.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-sidebar
      id="sidebar-right"
      right
      no-header
      shadow
      backdrop-variant="dark"
      backdrop
      aria-labelledby="sidebar-header"
    >
      <div class="slidebar-section p-0">
        <div id="sidebar-header" class="f_c_c p-1"></div>
        <div class="body-class"></div>
      </div>
    </b-sidebar>
    <!-- <router-view :key="refreshIndex"></router-view> -->
    <b-modal
      id="edit-modal"
      title="توجه"
      button-size="sm"
      size="lg"
      :hide-footer="footer"
      ref="confirm-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <div class="f-c-c f-d-c mb-5 mt-3">
          <h4>کاربر گرامی</h4>
          <br />
          <p>
            به اطلاع می رساند از تاریخ 10 خرداد ماه استفاده از سامانه منوط به خرید سرویس های تعیین
            شده می باشد.
          </p>
          <br />
          <div>
            لینک خرید :
            <a href="https://vadaroom.ec.iau.ir/my-gap/finance-list"
              >https://vadaroom.ec.iau.ir/my-gap/finance-list</a
            >
          </div>
        </div>
        <div class="btnSec w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c m-0" @click="confirmFunc()">تایید</div>
        </div>
      </template>
    </b-modal>
    <router-view></router-view>
  </div>
</template>
<script>
import { EventBus } from "@/assistant/EventBus";
import { mapState, mapActions } from "vuex";
export default {
  name: "GapRightNav",
  data() {
    return {
      isShowCopy: false,
      showMenu: true,
      footer: true,
      isabmenu: true,
      isChild: false,
      isHide: false,
      activeId: 1,
      childActiveId: 0,
      refreshIndex: 0,
      footerActiveId: 1,
      footerItems: [
        {
          title: "پروفایل من",
          pic: "profile-inactive-mobile",
          activePic: "profile-active-mobile",
          url: "myProfile",
          children: [],
        },
        {
          title: "جلسات من",
          pic: "meeting-inactive-mobile",
          activePic: "meeting-active-mobile",
          url: "myMeets",
          children: [
            {
              id: 0,
              title: "جلسات من",
              url: "myMeets",
            },
            {
              id: 1,
              title: "جلسات دعوت شده",
              url: "invitedMeetings",
            },
            {
              id: 2,
              title: "سازمان ها",
              url: "organization",
            },
            {
              id: 3,
              title: "گروه جلسات",
              url: "meetGroups",
            },
          ],
        },
        {
          title: "کاربران من",
          pic: "user-inactive-mobile",
          activePic: "user-active-mobile",
          url: "myUsers",
          children: [
            {
              id: 0,
              title: "کاربران من",
              url: "myUsers",
            },
            {
              id: 1,
              title: "گروه های کاربری",
              url: "userGroups",
            },
          ],
        },
        {
          title: "امور مالی",
          pic: "mali-inactive-mobile",
          activePic: "mali-active-mobile",
          url: "financeList",
          children: [],
        },
        // {
        //   title: "گزارشات",
        //   pic: "report-inactive-mobile",
        //   activePic: "report-active-mobile",
        //   url: "reports",
        //   children: [],
        // },
      ],
      navItems: [
        {
          title: "پروفایل من",
          pic: "profile-inactive-mobile",
          activePic: "profile-active-mobile",
          url: "myProfile",

          name: "پروفایل من",
          path: "myProfile",
          whiteIcon: "my-profile-white",
          greenIcon: "my-profile-blue",
          children: [],
          permision: false,
        },
        {
          title: "جلسات من",
          pic: "meeting-inactive-mobile",
          activePic: "meeting-active-mobile",
          url: "myMeets",

          name: "جلسات",
          path: "meets",
          whiteIcon: "meeting-white",
          greenIcon: "meeting-blue",
          permision: false,
          children: [
            {
              title: "جلسات من",
              url: "myMeets",

              id: 0,
              name: "جلسات من",
              path: "myMeets",
              permision: false,
            },
            {
              title: "جلسات دعوت شده",
              url: "invitedMeetings",

              id: 1,
              name: "جلسات دعوت شده",
              path: "invitedMeetings",
              permision: false,
            },
            {
              title: "سازمان ها",
              url: "organization",

              id: 2,
              name: "سازمان ها",
              path: "organization",
              permision: false,
            },
            {
              title: "گروه جلسات",
              url: "meetGroups",

              id: 3,
              name: "گروه جلسات ",
              path: "meetGroups",
              permision: false,
            },
          ],
        },
        {
          title: "کاربران من",
          pic: "user-inactive-mobile",
          activePic: "user-active-mobile",
          url: "myUsers",

          name: "کاربران",
          path: "users",
          whiteIcon: "users-white",
          greenIcon: "users-blue",
          permision: false,
          children: [
            {
              title: "کاربران من",
              url: "myUsers",

              id: 0,
              name: "کاربران من",
              path: "myUsers",
              permision: false,
            },
            {
              title: "گروه های کاربری",
              url: "userGroups",

              id: 1,
              name: "گروه های کاربری",
              path: "userGroups",
              permision: false,
            },
          ],
        },
        {
          title: "امور مالی",
          pic: "mali-inactive-mobile",
          activePic: "mali-active-mobile",
          url: "financeList",

          name: "امور مالی",
          path: "financeList",
          whiteIcon: "mali-white",
          greenIcon: "mali-blue",
          children: [],
          permision: false,
        },
        // {
        //   name: "گزارشات",
        //   path: "reports",
        //   whiteIcon: "report-white",
        //   greenIcon: "report-blue",
        //   permision: false,
        //   children: [
        //     {
        //       id: 0,
        //       name: "حضور و غیاب",
        //       path: "presenceAbsence",
        //       permision: true,
        //     },
        //     {
        //       id: 1,
        //       name: "حسابداری",
        //       path: "accounting",
        //       permision: true,
        //     },
        //   ],
        // },
      ],
    };
  },
  created() {
    if (!this.isLoginWithPass) {
      this.$router.push({ name: "login" });
    }
    EventBus.$on("copyright", (status) => {
      if (status && this.isShowCopy) {
        this.isShowCopy = false;
      }
    });
  },
  computed: {
    ...mapState({
      navNo: (state) => state.gap.navNo,
      subNavNo: (state) => state.gap.subNavNo,
      appTitle: (state) => state.gap.appTitle,
      user: (state) => state.gap.user,
      isLoginWithPass: (state) => state.gap.isLoginWithPass,
      firstEntry: (state) => state.gap.firstEntry,
      tStatus: (state) => state.gap.tStatus,
    }),
  },
  components: {},
  methods: {
    ...mapActions("gap", [
      "setNavNoFunction",
      "setSubNavNoFunction",
      "exitFunction",
      "setAppTitleFunction",
      "setFirstEntryFunction",
      "checkTokenStatusFunction",
    ]),
    confirmFunc() {
      this.$refs["confirm-modal"].hide();
    },
    navClickFunc() {
      setTimeout(() => {
        let nav = document.querySelectorAll(".rightNav .up a");
        nav[1].click();
      }, 500);
    },
    copyRightFunc() {
      this.isShowCopy = !this.isShowCopy;
    },
    activeFooterFunc(v) {
      switch (v) {
        case "myProfile":
          return 0;
        case "myMeets":
          return 1;
        case "myUsers":
          return 2;
        case "finance":
          return 3;
        case "reports":
          return 4;
      }
    },
    selectNavFunc(v, i) {
      this.isabmenu = true;
      this.setAppTitleFunction(v.name);
      this.activeId = i;
      this.childActiveId = 0;
      this.setNavNoFunction(i);
      this.refreshIndex = this.refreshIndex + 1;
      if (v.children.length) {
        let child = v.children.filter((item) => {
          return item.permision;
        });
        this.setSubNavNoFunction(child[0].id);
        // this.childActiveId = 0
        this.childActiveId = child[0].id;
        if (child[0].path !== this.$router.history.current.name) {
          this.$router.push({ name: child[0].path });
        }
      } else {
        if (v.path !== this.$router.history.current.name) {
          this.$router.push({ name: v.path });
        }
      }
      //mobile sec
      this.isabmenu = true;
      if (v.url !== this.$router.currentRoute.name) {
        this.setAppTitleFunction(v.title);
        this.footerActiveId = i;
        this.$router.push({ name: v.url });
        if (v.children.length == 0) {
          this.isChild = false;
        } else {
          this.isChild = true;
        }
      } else {
        this.setAppTitleFunction(v.title);
        this.footerActiveId = i;
        if (v.children.length == 0) {
          this.isChild = false;
        } else {
          this.isChild = true;
        }
      }
    },
    childSelectFunc(v, i) {
      this.setAppTitleFunction(v.name);
      this.childActiveId = v.id;
      this.isabmenu = false;
      this.setSubNavNoFunction(v.id);
      if (this.$router.history.current.name !== v.path) {
        this.$router.push({ name: v.path });
      }
      //mobile sec
      this.setAppTitleFunction(v.title);
      this.isChild = false;
      if (v.url !== this.$router.currentRoute.name) {
        this.$router.push({ name: v.url });
      }
    },
    hideNavFunc() {
      this.isabmenu = true;
      if (this.showMenu) {
        $(".linkText").fadeOut("800");
        $(".children").fadeOut("800");
        setTimeout(() => {
          this.showMenu = !this.showMenu;
          this.isHide = !this.isHide;
        }, 250);
      } else {
        this.isHide = !this.isHide;
        setTimeout(() => {
          this.showMenu = !this.showMenu;
        }, 500);
      }
    },
    exitFunc() {
      this.exitFunction();
      this.$router.push({ name: "login" });
    },
    // goToPageFunc(v, i) {
    //   this.isabmenu = true;
    //   if (v.url !== this.$router.currentRoute.name) {
    //     this.setAppTitleFunction(v.title);
    //     this.footerActiveId = i;
    //     this.$router.push({ name: v.url });
    //     if (v.children.length == 0) {
    //       this.isChild = false;
    //     } else {
    //       this.isChild = true;
    //     }
    //   } else {
    //     this.setAppTitleFunction(v.title);
    //     this.footerActiveId = i;
    //     if (v.children.length == 0) {
    //       this.isChild = false;
    //     } else {
    //       this.isChild = true;
    //     }
    //   }
    // },
    // goToChildPageFunc(v) {
    //   this.setAppTitleFunction(v.title);
    //   this.isChild = false;
    //   if (v.url !== this.$router.currentRoute.name) {
    //     this.$router.push({ name: v.url });
    //   }
    // },
  },
  watch: {},
  mounted() {
    this.checkTokenStatus = setInterval(() => {
      if (this.tStatus) {
        this.checkTokenStatusFunction(this.tStatus - 60000);
      } else {
        clearInterval(this.checkTokenStatus);
        this.$bvToast.toast("نشست شما به پایان رسیده است.", {
          title: "توجه",
          variant: "danger",
          solid: true,
        });
        setTimeout(() => {
          this.exitFunc();
        }, 4000);
      }
    }, 60000);
    if (this.user.permissions.show_finance_list && this.firstEntry) {
      //this.$refs["confirm-modal"].show();
      setTimeout(() => {
        this.setFirstEntryFunction(false);
      }, 500);
    }
    if (this.user.is_organ !== "no") {
    }
    window.addEventListener(
      "resize",
      (e) => {
        if (e.target.innerHeight < 600) {
          document.querySelector("#app .gap .rightNav").classList.add("navHeightLess");
        } else {
          document.querySelector("#app .gap .rightNav").classList.remove("navHeightLess");
        }
      },
      true
    );
    let childnav = 0;
    let ischildnav = false;
    for (let i = 0; i < this.navItems.length; i++) {
      if (this.navItems[i].path == "myProfile") {
        this.navItems[i].permision = this.user.permissions.my_profile;
      }
      if (this.navItems[i].path == "meets") {
        this.navItems[i].permision = this.user.permissions.session;
      }
      if (this.navItems[i].path == "users") {
        this.navItems[i].permision = this.user.permissions.users;
      }
      if (this.navItems[i].path == "financeList") {
        this.navItems[i].permision = this.user.permissions.finance;
      }
      if (this.navItems[i].path == "reports") {
        this.navItems[i].permision = this.user.permissions.reports;
      }
      if (this.navItems[i].children.length) {
        for (let j = 0; j < this.navItems[i].children.length; j++) {
          if (this.navItems[i].children[j].path == "myMeets") {
            this.navItems[i].children[j].permision = this.user.permissions.my_session;
            if (this.user.permissions.my_session) {
              childnav = j;
              ischildnav = true;
            }
          }
          if (this.navItems[i].children[j].path == "invitedMeetings") {
            this.navItems[i].children[j].permision = this.user.permissions.invited_session;
            if (this.user.permissions.invited_session && !ischildnav) {
              childnav = j;
              this.$router.push({ name: "invitedMeetings" });
            }
          }
          if (this.navItems[i].children[j].path == "organization") {
            if (this.user.is_organ == "yes") {
              this.navItems[i].children[j].permision = this.user.permissions.organs;
            } else {
              this.navItems[i].children[j].permision = false;
            }
          }
          if (this.navItems[i].children[j].path == "meetGroups") {
            this.navItems[i].children[j].permision = this.user.permissions.sessions_group;
          }
          if (this.navItems[i].children[j].path == "myUsers") {
            if (this.user.is_organ == "yes") {
              this.navItems[i].children[j].permision = this.user.permissions.my_users;
            } else {
              this.navItems[i].children[j].permision = false;
            }
          }
          if (this.navItems[i].children[j].path == "userGroups") {
            this.navItems[i].children[j].permision = this.user.permissions.user_groups;
          }
        }
      }
    }
    this.footerActiveId = this.activeFooterFunc(this.$router.history.current.name);
    if (Object.keys(this.user).length == 0) {
      this.$router.push({ name: "login" });
    } else {
      if (!this.user.user_id) {
        this.$router.push({ name: "login" });
      }
    }
    if (this.navNo === null) {
      this.activeId = 1;
      this.childActiveId = childnav;
      // this.navClickFunc();
    } else {
      this.activeId = this.navNo;
      this.childActiveId = this.subNavNo;
    }
  },
};
</script>
